import React from "react";
import PropTypes from "prop-types";
import { Paper, Typography, Button } from "@mui/material";
import PendingIcon from "../assets/icons/pendingIcon.svg";
import SuccessIcon from "../assets/icons/successIcon.svg";

const SuccessModal = ({ isPending, modalText, btnText, onReqClick }) => {
	return (
		<Paper
			sx={{
				width: "83%",
				maxWidth: "320px",
				borderRadius: "8px",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				gap: 2,
				padding: 3,
			}}>
			<img src={isPending ? PendingIcon : SuccessIcon} alt='status-icon' width={75} height={75} />
			<Typography textAlign='center'>{modalText}</Typography>
			<Button variant='contained' color='primary' sx={{ width: "100%" }} onClick={onReqClick}>
				{btnText}
			</Button>
		</Paper>
	);
};

SuccessModal.propTypes = {
	isPending: PropTypes.bool,
	modalText: PropTypes.string,
	btnText: PropTypes.string,
	onReqClick: PropTypes.func,
};

export default SuccessModal;
